import { render, staticRenderFns } from "./AssociationDetail.vue?vue&type=template&id=7bbec7d0&scoped=true&"
import script from "./AssociationDetail.vue?vue&type=script&lang=js&"
export * from "./AssociationDetail.vue?vue&type=script&lang=js&"
import style0 from "./AssociationDetail.vue?vue&type=style&index=0&id=7bbec7d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbec7d0",
  null
  
)

export default component.exports